import { useContext, useState } from "react";
import {useMap, useToggle} from 'react-use';
import log from "loglevel";

import { toMeters, toAcres } from "../utils/convertor";


import SectionTitle from "../components/title.js";
import StatsGroup from "../components/stats-group";
import AutoHeightEmbed from "../components/auto-height-embed";
import ResponsiveEmbed from "../components/responsive-embed";
import LargeCard from "../components/large-card";
import MapDrawBoundary from "../components/map-draw-boundary";

import SitePlanContext from "../utils/siteplan-context";

const DrawSite = (props) => {
  const sitePlanContext = useContext(SitePlanContext);
  const [showMarkers, toggleMarkers] = useToggle(true);

  const markers = {
    type: "number",
    title: "Markers",
    value: sitePlanContext.poiMarkers.length,
    unit: '',
    extra: null,
    clickable: true,
    checked: showMarkers,
    onClick:toggleMarkers
  };

  const points = {
    type: "number",
    title: "Vertexes",
    value: sitePlanContext.sitePlanCoords.length,
    unit: '',
    extra: null
  };

  const [area, {setAll:setArea}] = useMap({
    type: "number",
    title: "Total Area",
    value: 0,
    unit: 'x',
    extra: null
  });

  const [boundary, {setAll:setBoundary}] = useMap({
    type: "number",
    title: "Boundary",
    value: 0,
    unit: 'x',
    extra: null
  });

  const updateMapData = data => {
    setArea({...area, ...toAcres(data.area)});
    setBoundary({...boundary, ...toMeters(data.length)});
  }

  // log.info('Drawing '+props.title);

  return (
    <>
      <section>
        <StatsGroup stats={[markers, points, area, boundary]} />
      </section>
      <section className="card">
        <MapDrawBoundary onUpdate={updateMapData} showMarkers={showMarkers} />
      </section>
    </>
  );
};

export default DrawSite;
